import { motion } from 'framer-motion';
import { X, Share, Plus } from 'lucide-react';

interface IOSInstallGateModalProps {
  onShowGuide: () => void;
  onDismiss: () => void;
}

export function IOSInstallGateModal({ onShowGuide, onDismiss }: IOSInstallGateModalProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onDismiss();
      }}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.78)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
      }}
      data-testid="ios-install-gate"
    >
      <motion.div
        initial={{ y: 30, opacity: 0, scale: 0.96 }}
        animate={{ y: 0, opacity: 1, scale: 1 }}
        exit={{ y: 30, opacity: 0, scale: 0.96 }}
        transition={{ type: 'spring', damping: 26, stiffness: 320 }}
        style={{
          background: 'linear-gradient(180deg, #1a0a14 0%, #0d0508 100%)',
          border: '1px solid rgba(225,29,72,0.4)',
          borderRadius: 22,
          padding: '24px 22px 20px',
          maxWidth: 420,
          width: '100%',
          position: 'relative',
          textAlign: 'center',
        }}
      >
        <button
          onClick={onDismiss}
          aria-label="Dismiss"
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'rgba(255,255,255,0.06)',
            border: 'none',
            borderRadius: '50%',
            width: 30,
            height: 30,
            color: 'rgba(255,255,255,0.6)',
            cursor: 'pointer',
          }}
        >
          <X size={16} />
        </button>
        <div
          style={{
            fontSize: 38,
            margin: '4px auto 12px',
          }}
          aria-hidden
        >
          📲
        </div>
        <h2 style={{ color: 'white', fontSize: 22, fontWeight: 800, margin: '0 0 8px' }}>
          Add to Home Screen
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 14, margin: '0 0 16px', lineHeight: 1.5 }}>
          Install Papacito to get notifications when she likes you, matches, or sends a message.
        </p>
        <div
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 12,
            padding: '12px 14px',
            margin: '0 0 18px',
            textAlign: 'left',
            fontSize: 13,
            color: 'rgba(255,255,255,0.8)',
            lineHeight: 1.6,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <Share size={16} color="#60a5fa" /> Tap the Share button in Safari
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Plus size={16} color="#34d399" /> Choose “Add to Home Screen”
          </div>
        </div>
        <button
          onClick={onShowGuide}
          style={{
            width: '100%',
            background: '#e11d48',
            color: 'white',
            border: 'none',
            borderRadius: 12,
            padding: '14px',
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Show me how
        </button>
        <button
          onClick={onDismiss}
          style={{
            width: '100%',
            background: 'transparent',
            color: 'rgba(255,255,255,0.5)',
            border: 'none',
            padding: '12px',
            fontSize: 13,
            cursor: 'pointer',
            marginTop: 4,
          }}
        >
          Not now
        </button>
      </motion.div>
    </motion.div>
  );
}
